const img = document.querySelector('img.mega-placeholder');
if (img) {
    new MutationObserver(() => {
        img.classList.remove('is-swapping');
        void img.offsetWidth;
        img.classList.add('is-swapping');
    }).observe(img, { attributes: true, attributeFilter: ['src'] });
}
